import { createFileRoute } from '@tanstack/react-router';
import { OverviewTab } from '../../../../features/B4/Overview';

/** Client overview tab: stats, readiness, details, activate/pause, kill switch, recent messages. */
export const Route = createFileRoute('/_app/client/$clientId/')({
  component: OverviewTab,
});
